import { timeSlots } from "./dashTime";

export function getLatestPastSlot(date) {


  const nowInJapan = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
  );
  nowInJapan.setMinutes(nowInJapan.getMinutes() - 1);
  const japanHour = nowInJapan.getHours();

  const isFutureSlot = (date, timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const slotDate = new Date(
      `${date}T${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:00`
    );
    return slotDate > nowInJapan;
  };

  for (let i = timeSlots.length - 1; i >= 0; i--) {
    if (!isFutureSlot(date, timeSlots[i])) {
      // return `${date} ${timeSlots[i]}`;
      if (japanHour < 9) {
        return `${date} ${timeSlots[i]}`;
      } else {
        return `${date} 09:00`;
      }
    }
  }

  return null;
}
